import RecentSearchAndPopularsMobile from './RecentSearchAndPopularsMobile';

export default RecentSearchAndPopularsMobile;
